// extracted by mini-css-extract-plugin
module.exports = {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","menuHeader":"#f9f9fa","TextInput":"tq_a vh_z vh_is vh_nj vh_tb vh_cw","TextInput--disabled":"tq_b"};